import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_BASE_URL } from '../config';

export default function ResetPassword() {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    useEffect(() => {
        if (!token) {
            setError('Geçersiz şifre sıfırlama bağlantısı. Lütfen yeni bir sıfırlama bağlantısı isteyin.');
        }
    }, [token]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        
        if (password.length < 6) {
            setError('Şifre en az 6 karakter olmalıdır.');
            return;
        }
        
        if (password !== confirmPassword) {
            setError('Şifreler eşleşmiyor.');
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            const response = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    token: token,
                    newPassword: password
                })
            });

            const data = await response.json();

            if (data.success) {
                setSuccess(true);
            } else {
                setError(data.message || 'Şifre güncelleme işlemi başarısız oldu.');
            }
        } catch (error) {
            setError('Sunucuya bağlanırken bir hata oluştu.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{minHeight: '100vh', backgroundColor: '#f5f5f5', padding: '50px 20px'}}>
            <div style={{maxWidth: '400px', margin: '0 auto', backgroundColor: 'white', padding: '40px', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)'}}>
                <div style={{textAlign: 'center', marginBottom: '30px'}}>
                    <h1 style={{color: '#ef4444', marginBottom: '10px'}}>🕌 Hatim Takip</h1>
                    <p style={{color: '#666'}}>Şifre Sıfırlama</p>
                </div>

                {success ? (
                    <div style={{textAlign: 'center'}}>
                        <h2 style={{color: '#22c55e', marginBottom: '20px'}}>✅ Başarılı!</h2>
                        <p style={{marginBottom: '20px'}}>Şifreniz başarıyla güncellendi.</p>
                        <a href="https://play.google.com/store/apps/details?id=com.hatimtakip" 
                           style={{display: 'block', padding: '10px', backgroundColor: '#ef4444', color: 'white', textDecoration: 'none', borderRadius: '5px', marginBottom: '10px'}}>
                            📱 Uygulamaya Dön
                        </a>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        {error && (
                            <div style={{backgroundColor: '#fee2e2', color: '#dc2626', padding: '10px', borderRadius: '5px', marginBottom: '20px'}}>
                                {error}
                            </div>
                        )}
                        
                        <div style={{marginBottom: '20px'}}>
                            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Yeni Şifre:</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '5px'}}
                                placeholder="En az 6 karakter"
                                disabled={!token || isLoading}
                                required
                            />
                        </div>

                        <div style={{marginBottom: '20px'}}>
                            <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Şifre Tekrar:</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '5px'}}
                                placeholder="Şifreyi tekrar girin"
                                disabled={!token || isLoading}
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={!token || isLoading}
                            style={{
                                width: '100%', 
                                padding: '12px', 
                                backgroundColor: isLoading ? '#ccc' : '#ef4444', 
                                color: 'white', 
                                border: 'none', 
                                borderRadius: '5px', 
                                fontSize: '16px',
                                cursor: isLoading ? 'not-allowed' : 'pointer'
                            }}
                        >
                            {isLoading ? '⏳ Güncelleniyor...' : '🔐 Şifremi Güncelle'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
